module.exports = __webpack_public_path__ + "3ddf587800c13da36bfc67471a56e177.pdf";